


















































import http from "@/axios/http-common";
import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";

interface ItemObat {
  nama: string;
  qty: number;
  satuan: string;
  signa: string;
  harga: number;
  countedHarga: number;
}

const currencyFormatter = new Intl.NumberFormat("id-ID", {
  style: "currency",
  currency: "IDR",
});

@Component
export default class ObatItemRow extends Vue {
  public rules = {
    required: (value) => !!value || "Kolom ini harus diisi",
  };
  loading = false;
  items = [];
  val = "";
  search = null;
  select = null;
  list = [{ val: null, search: null }];
  entries = [];
  signaLoading = false;
  _timerId;

  @Prop() item: ItemObat;

  @Prop() index: number;

  @Prop() color: string;

  @Ref() qty: HTMLInputElement;

  mounted() {
    this.$nextTick(() => {
      this.qty.focus();
    });
  }

  formatHarga(harga) {
    return currencyFormatter.format(harga);
  }

  countHarga(item: ItemObat) {
    item.countedHarga = item.qty * item.harga;
    this.$emit("sum-total-harga");
  }

  triggerSubmit() {
    this.$emit("trigger-submit");
  }

  removeItem(index) {
    this.$emit("remove-item", index);
  }

  @Watch("search", { deep: true })
  changedSearch() {
    this.entries = [];

    clearTimeout(this._timerId);

    this._timerId = setTimeout(() => {
      if (
        this.search === null ||
        this.search.length < 2 ||
        this.item.signa === this.search
      )
        return;

      this.signaLoading = true;

      http
        .getDataParam("/template/signa/search", {
          params: { term: this.search },
        })
        .then((res) => {
          this.entries = res.data.map((signa) => {
            return signa.text;
          });

          if (!res.data.length) {
            this.item.signa = this.search;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => (this.signaLoading = false));
    }, 500);
  }
}
